import React, { useState } from 'react';
import { NavLink, Link } from 'react-router-dom';
import MyDropDown from '../../../../components/common/myDropDown/MyDropDown';
import UserDropdown from './components/UserDropdown/UserDropdown';
import Tooltip from '../../../../components/common/tooltip/Tooltip';
import styles from './header.css';
import LogoIcon from '../../../../assets/img/playrence-logo.png';
import DashboardIcon from '../../../../assets/svg/dashboard.svg';
import PlusIcon from '../../../../assets/svg/plus.svg';
import VideoBack from '../../../../assets/svg/ondemand_video_black_24dp.svg';
import { useSelector } from 'react-redux';
import ReactDOM from 'react-dom';
import ApiSettings from '../../pages/dashboard/components/apiSettings/ApiSettings';
import ProtectedComponent from '../../../../components/protectedComponent/ProtectedComponent';

/***********************************************************************************************************************
 *
 * @type {React.NamedExoticComponent<{profile?: *, content?: *, handleOpenTemplateWizard?: *}>}
 **********************************************************************************************************************/

const Header = React.memo( ( { handleOpenTemplateWizard } ) => {

    const { localization: { content }, profile } = useSelector( ( state ) => state );
    const [ showApi, setShowApi ] = useState( false );
    const apiHandle = () => {
        setShowApi( !showApi );
    };

    return (
        <div className={ styles.wrapper }>
            <Link
                to='/dashboard/quizes'
                className={ styles.logo }
            >
                <img src={LogoIcon}
                    alt='Playrence logo'
                    style={ {
                        width: '4.2rem',
                        height: '4.2rem'
                    } }
                />
            </Link>
            <ul className={ styles.navMenu }>
                <NavLink
                    exact
                    to='/dashboard/quizes'
                    className={ styles.navBar }
                    activeClassName={ styles.active }
                >
                    <div className={ styles.navBarContent }>
                        <DashboardIcon
                            style={ {
                                fill: '#fff',
                                width: '1.8rem',
                                height: '1.8rem'
                            } }
                        />
                        <span className={ styles.navBarText }>
                                { content.dashboard.dashboard }
                        </span>
                    </div>

                </NavLink>
                <ProtectedComponent permissions={['quiz_create']}>
                <div
                    className={styles.createButtonWrapper}
                    onClick={handleOpenTemplateWizard}
                >
                    <div className={styles.createButton}>
                        <PlusIcon
                            style={{
                                fill: '#fff',
                                width: '1.4rem',
                                height: '1.4rem'
                            }}
                        />
                        <span className={styles.createButtonText}>
                            {content.dashboard.new_template}
                        </span>
                    </div>
                </div>
                </ProtectedComponent>

            </ul>
            <div className={ styles.searchAccountLanguagesWrapper }>
                {/* <NavLink
                    exact
                    to='/dashboard/tutorials'
                    className={ styles.navBar }
                    activeClassName={ styles.active }
                >
                    <div className={ styles.navBarContent }>
                        <VideoBack
                            style={ {
                                fill: '#fff'
                            } }
                        />
                        <span className={ styles.navBarText }>
                            { content.tutorial }
                        </span>
                    </div>

                </NavLink> */}
                <MyDropDown/>
                <div>
                    <Tooltip 
                        trigger={
                            <div className={styles.profileUserMain}>
                                <img src={profile.avatar_url}
                                    alt="avatar"
                                    style={ {
                                        width: '30px',
                                        height: '30px',
                                        borderRadius:'100px',
                                    } }
                                    onClick={ e => {
                                        e.preventDefault();
                                    } }></img>
                                    <p className={styles.profileUserLabel}>{ profile.name }</p>
                            </div>
                        }
                        content={ <UserDropdown profile={ profile } content={ content } showApi={ showApi }
                            apiHandle={ apiHandle }/> }
                    />
                </div>
                
                { showApi && ReactDOM.createPortal( <ApiSettings
                    closeHandle = { apiHandle }/>, document.getElementById( 'library' ) ) }
            </div>
        </div>
    );

} );

export default Header;